import React from 'react';
import { connect } from 'react-redux';
import ReportItem from '../ReportItem/ReportItem.js';

import * as Constants from "../../Common/constants";
export class ReportFeedPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = { serverErrors: {} };


        console.info('ReportFeedPage - constructor called.');
    }

    componentWillMount() {
        console.info('ReportFeedPage - componentWillMount called.');
    }

    componentDidMount() {
        console.info('ReportFeedPage - componentDidMount called.');

    }

    componentWillReceiveProps(nextProps) {
        console.info('ReportFeedPage - componentWillReceiveProps called.');

        if (nextProps.lastitem) {
            console.info('ReportFeedPage - lastitem.');
        }
    }

    shouldComponentUpdate() {
        return true;
    }

    componentWillUpdate() {
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }


    onChange(e) {

    }


    render() {
        console.info('ReportFeedPage - render called.', this.props.leaderboard);
        if (!this.props.leaderboard) {
            return (<div>Loading leaderboard...</div>);

        }
        let events = this.props.leaderboard.events;
        let items = new Array();
        events.forEach(element => {
            items.push(<ReportItem key={element.timeinms} data={element} />);
        });
        return items;

    }


}

/**
 * Get data from store
 * @param state
 */
const mapStateToProps = state => ({
    leaderboard: state.leaderboard.leaderboard,
    lastitem: state.leaderboard.last,
});

/**
 * Import action from dir action above - but must be passed to connect method in order to trigger reducer in store
 * @type {{UserUpdate: UserUpdateAction}}
 */
const mapActionsToProps = {

};

export default connect(mapStateToProps, mapActionsToProps)(ReportFeedPage);



// WEBPACK FOOTER //
// ./src/Components/ReportFeedPage/ReportFeedPage.js